import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'content-card',
    templateUrl: './content-card.component.html',
    styleUrls: ['./content-card.component.css'],
    imports: [CommonModule]
})
export class ContentCardComponent {

}